<div class="w-full bg-secondary-background py-8">
  <!-- Title Section -->
  <div class="mb-4">
    <h1 class="rimary-text sm:text-4xl lg:text-6xl">
      {{ 'pages.editions.previousEditionsTitle' | translate }}
    </h1>
  </div>

  <!-- Subtext and Button Section -->
  <div class="mb-8 flex flex-col items-center justify-between md:flex-row">
    <p class="mb-4 text-sm text-primary-text sm:text-base md:mb-0 md:text-lg">
      {{
        'pages.editions.previousEditionsDescription'
          | translate: { magazineName: magazine.title ?? '' | articleForName }
      }}
    </p>
    <button
      class="w-full rounded-full border border-primary-text px-4 py-2 text-center text-primary-text transition-colors duration-300 hover:bg-primary-text hover:text-primary-on md:w-auto"
      [routerLink]="['/', 'magazines', 'detail', magazine.id, magazine.slug]"
    >
      {{ 'pages.editions.allEditionsButton' | translate }}
    </button>
  </div>

  <!-- Scrollable Editions Section -->
  <div class="relative">
    <div
      class="scrollbar-hide flex gap-4 space-x-4 overflow-x-auto pb-4"
      #scrollContainer
      (mousedown)="onDragStart($event)"
      (mousemove)="onDragMove($event)"
      (mouseup)="onDragEnd()"
      (mouseleave)="onDragEnd()"
      (touchstart)="onDragStart($event)"
      (touchmove)="onDragMove($event)"
      (touchend)="onDragEnd()"
    >
      <!-- Edition Cards -->
      @for (edition of previousEditions(); track edition) {
        <div
          class="edition-card flex flex-none cursor-pointer flex-col items-start justify-start bg-secondary-background p-3 transition-transform hover:scale-105 sm:p-4"
          [routerLink]="[
            '/magazines/detail',
            magazine.id,
            magazine.slug,
            'edition',
            edition.id,
          ]"
        >
          @if (magazine.media?.cover; as cover) {
            <div class="flex-grow">
              <img
                class="w-full max-w-xxs transform object-cover transition-transform duration-300 group-hover:scale-105"
                [ngSrc]="cover.url ?? '/assets/images/image-placeholder.png'"
                [alt]="'magazines.images.cover' | translate"
                width="150"
                height="200"
              />
            </div>
          }
          <div class="mt-3 flex w-full items-center justify-center gap-3">
            <span
              class="self-stretch text-base leading-normal font-medium text-primary-text sm:text-lg md:text-xl"
            >
              {{
                'common.editionTitle'
                  | translate
                    : { year: edition.year, edition: edition.edition_version }
              }}
            </span>
            <img
              class="ml-auto h-3 w-3"
              src="assets/icons/diagonal_arrow_icon.svg"
              alt="Arrow icon"
            />
          </div>
          <div class="text-sm text-gray-500 md:text-base">
            <span>{{
              edition.published_at ?? edition.createdAt | localizedDate
            }}</span>
          </div>
        </div>
      }
    </div>

    <!-- Navigation Controls -->
    <div class="mt-4 flex items-center justify-end">
      <!-- Arrow Controls -->
      @if (pages.length > 1) {
        <div class="flex space-x-4">
          <button
            class="btn btn-icon-only btn-outline"
            [disabled]="currentPage() === 1"
            (click)="scrollPreviousPage()"
            aria-label="Previous page"
          >
            <img
              class="h-6 w-6"
              src="assets/icons/arrow_left_icon.svg"
              alt="Left arrow"
            />
          </button>
          <button
            class="btn btn-icon-only btn-outline"
            [disabled]="currentPage() >= pages.length - 1"
            (click)="scrollNextPage()"
            aria-label="Next page"
          >
            <img
              class="h-6 w-6 rotate-180 transform"
              src="assets/icons/arrow_left_icon.svg"
              alt="Right arrow"
            />
          </button>
        </div>
      }
    </div>
  </div>
</div>
